import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {buttonTypes} from '@ispm/shared/components/button/button.component';
import {Widget} from '@ispm/widgets/decorator/widget.decorator';
import {IWidgetItem} from '@ispm/widgets/interfaces/widget-item.interface';
import {IdynamicFormItem} from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import {IPopupEditorCallerPayload} from '@ispm/widgets/components/popup-editor-caller/popup-editor-caller-payload.interface';
import {FormHandlerService} from '@ispm/dynamic-form/services/form-handler.service';
import {isEmpty} from 'lodash';
import {filter} from 'rxjs/operators';
import {modalResponse} from '@ispm/layout/constants/modal-responses.enum';

@Component({
    selector: 'ispm-popup-editor-caller',
    templateUrl: './popup-editor-caller.component.html',
    styleUrls: ['./popup-editor-caller.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('PopupEditorCaller')
export class PopupEditorCallerComponent implements OnInit, IWidgetItem<IPopupEditorCallerPayload> {
    public static counter: number = 1;

    @Input()
    public buttonType: buttonTypes = buttonTypes.emphasis;

    @Input()
    public icon: string = 'fa fa-pencil';

    @Input()
    public text: string;

    @Input()
    public editorTitle: string;

    @Input()
    public active: boolean = false;

    @Input()
    public disabledStatus: boolean = false;

    private formId: string;
    private formConfig: IdynamicFormItem[];

    private _data: any;
    private approveBtnText: string = 'Save';
    private declineBtnText: string = 'Cancel';
    private editorChannel: string;

    public set widgetDisabledStatus(disabledStatus: boolean) {
        this.disabledStatus = disabledStatus;
    }

    set widgetConfig(widgetConfig: IdynamicFormItem<IPopupEditorCallerPayload>) {
        Object.assign(this, widgetConfig.widgetPayload);

    }

    set widgetData(widgetData: any) {
        this.active = !isEmpty(widgetData);
        this._data = widgetData;
    }

    constructor(private formHandler: FormHandlerService) {
        this.editorChannel = 'EDITOR_' + PopupEditorCallerComponent.counter++;
    }

    widgetUpdateValueCallback: (value) => void;

    ngOnInit() {
    }

    callEditor() {
        // this.formHandler.popupDynamicFormModal(this.editorTitle, this.formId || this.formConfig, this._data, this.approveBtnText, this.declineBtnText, {}, this.editorChannel)
        //     .pipe(filter(res => res.data === modalResponse.approve))
        //     .subscribe(data => {
        //         this.widgetUpdateValueCallback(data.payload.formData );
        //     });
    }


}
